import SectionGroupsService from "external-services/section-groups-service/sectionGroups.service";
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';

const NS = 'SectionGroupsCtrl';

export default function SectionGroupsCtrl(
  $rootScope, $scope, $log, $mdDialog, $mdToast, $filter, $timeout, unregister
) {
  "ngInject";

  const vm = this;

  let highestOrder;
  let saveInterval;

  //-- define public properties
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  //-- define public methods
  vm.save = save;
  vm.tryAgain = tryAgain;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.addSectionGroup = addSectionGroup;
  vm.editSectionGroup = editSectionGroup;
  vm.deleteSectionGroup = deleteSectionGroup;

  //-- listen
  var listeners = [];
  // listeners.push($rootScope.$on('pouch-synced-doctype-section-group', getSectionGroups));
  listeners.push(PouchActions.handlePouchSyncedDoctype(PouchDocType.sectionGroup, () => getSectionGroups()));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  getSectionGroups();

  function getSectionGroups() {
    SectionGroupsService.getSectionGroups().then(function (sectionGroups) {
      vm.sectionGroups = $filter('orderBy')(sectionGroups, 'order');
      var lastOrder = 0;
      for (var i = 0; i < vm.sectionGroups.length; i++) {
        var sectionGroup = vm.sectionGroups[i];
        if (!isNaN(sectionGroup.order)) {
          if (sectionGroup.order === lastOrder) {
            sectionGroup.order = lastOrder += 1;
          }
        } else {
          sectionGroup.order = lastOrder += 1;
        }
        lastOrder = sectionGroup.order;
      }
      highestOrder = lastOrder;

      vm.state = vm.ENTER;
    }).catch(function (err) {
      $log.error('sectionGroups failed to load', err);
    });
  }

  function moveUp(index, sectionGroup) {
    var aboveItem = vm.sectionGroups[index - 1];
    var aboveOrder = aboveItem.order;
    aboveItem.order = sectionGroup.order;
    sectionGroup.order = aboveOrder;
    vm.sectionGroups = $filter('orderBy')(vm.sectionGroups, 'order');
    saveDelay();
  }

  function moveDown(index, sectionGroup) {
    var belowItem = vm.sectionGroups[index + 1];
    var belowOrder = belowItem.order;
    belowItem.order = sectionGroup.order;
    sectionGroup.order = belowOrder;
    vm.sectionGroups = $filter('orderBy')(vm.sectionGroups, 'order');
    saveDelay();
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function saveDelay() {
    vm.waitingToSave = true;
    if (saveInterval) {
      $timeout.cancel(saveInterval);
    }
    saveInterval = $timeout(save, 2000);
  }

  function save() {
    vm.state = vm.LOADING;
    SectionGroupsService.saveSectionGroups(vm.sectionGroups).then(function () {
      vm.state = vm.ENTER;
      $mdToast.show(
        $mdToast.simple()
          .content('Section Groups Saved')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );
      vm.waitingToSave = false;
    }).catch(function () {
      vm.state = vm.ERROR;
    });
  }

  function deleteSectionGroup(evt, sectionGroup) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Are you sure?')
      .content('Delete section group ' + sectionGroup.name)
      .ariaLabel('Delete Section Group')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      SectionGroupsService.deleteSectionsGroup(sectionGroup);
    });
  }

  function addSectionGroup(evt) {
    $mdDialog.show({
      controller: 'EditSectionGroupCtrl',
      controllerAs: 'vm',
      clickOutsideToClose: true,
      locals: {
        sectionGroup: null,
        highestOrder: highestOrder
      },
      templateUrl: 'app/settings/sections/editSectionGroup.html',
      targetEvent: evt
    });
  }

  function editSectionGroup(evt, sectionGroup) {
    if (!vm.waitingToSave) {
      $mdDialog.show({
        controller: 'EditSectionGroupCtrl',
        controllerAs: 'vm',
        clickOutsideToClose: true,
        locals: {
          sectionGroup: sectionGroup,
          highestOrder: highestOrder
        },
        templateUrl: 'app/settings/sections/editSectionGroup.html',
        targetEvent: evt
      });
    }
  }
}
